<i18n lang="yaml">
pt:
  new-project: "Novo projeto"
  active-projects: "Projetos ativos"
  disabled-projects: "Projetos desativados"
  project-to-manager: "Qual projeto você quer gerenciar hoje?"
  hero-title: "Você só precisa decidir por onde vamos começar"
  hero-subtitle: "Alta performance, de um jeito simples e ágil."
</i18n>

<template>
  <ModalCloneApp />

  <ModalCreateApp v-if="isMasterUser" />

  <section class="hero p-relative">
    <div
      data-grid="column"
      class="hero__wrapper wrapper grid--center"
    >
      <div class="hero__floating-logo p-absolute opacity-3">
        <img
          alt="Increazy"
          :src="require('../../../assets/images/logos/dash-square-light.webp')"
        >
      </div>

      <h1 class="hero__title">
        {{ $t('project-to-manager') }}
      </h1>

      <h3 class="hero__subtitle">
        {{ $t('hero-subtitle') }} {{ $t('hero-title') }}.
      </h3>

      <div
        data-grid
        class="hero__controls grid--between grid--va-center"
      >
        <div class="hero__filtering">
          <div
            class="d-contents"
            @click="setFilter('apps.status', 1, true)"
          >
            <FilteringButton
              :is-active="getFilters('apps').status === 1"
              :quantity="status?.true ?? 0"
              :label="$t('active-projects')"
            />
          </div>

          <div
            class="d-contents"
            @click="setFilter('apps.status', 0, true)"
          >
            <FilteringButton
              :is-active="getFilters('apps').status === 0"
              :quantity="status?.false ?? 0"
              :label="$t('disabled-projects')"
              class="ms-5"
            />
          </div>
        </div>

        <DefaultButton
          v-if="isMasterUser"
          :text="$t('new-project')"
          class="uppercase defaultbutton--black text-uppercase"
          @click="emitter.emit('toggle-modal', 'createApp')"
        >
          <PlusIcon class="icon" />

          {{ $t('new-project') }}
        </DefaultButton>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'

import PlusIcon from '../../../icons/PlusIcon'
import DefaultButton from '../../../global/Button'
import ModalCloneApp from '../modals/ModalCloneApp'
import ModalCreateApp from '../modals/ModalCreateApp'
import FilteringButton from '../../../global/FilteringButton'

export default defineComponent({
  name: 'Hero',

  components: {
    PlusIcon,
    DefaultButton,
    ModalCloneApp,
    ModalCreateApp,
    FilteringButton
  },

  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      getApps: 'apps/getApps'
    }),

    status () {
      return this.getApps.counters?.status
    },

    isMasterUser () {
      const { user } = this

      return user?.email === 'master@increazy.com'
    }
  },

  methods: {
    ...mapActions({
      toggleModalVisibility: 'apps/toggleModalCreateAppVisibility'
    })
  }
})
</script>

<style lang="scss" scoped>
.hero {
  border-top: solid 1px rgba(var(--white), .35);
  background: linear-gradient(90.89deg, var(--primary) 0%, var(--primary-light) 99.79%);

  &__wrapper {
    height: 415px;
    color: rgb(var(--white));
  }

  &__title {
    margin: 0 0 26px;
    font: 100 min(7vw, 4.9rem) / 1.2 "Archivo", sans-serif;
  }

  &__subtitle {
    max-width: 610px;
    font: 700 min(4vw, 2.5rem) / 1.2 "Archivo", sans-serif;
  }

  &__controls {
    z-index: 1;
    margin-block: 57px 0;
  }

  &__floating-logo {
    z-index: 0;

    width: 300px;

    top: 50%;
    right: 200px;
    transform: translateY(-50%);

    img {
      mask-image: linear-gradient(
          to bottom,
          rgb(var(--black)),
          var(--transparent)
      );
    }
  }

  .defaultbutton {
    height: 35px;
  }
}
</style>
